<div class="Page">
  <app-nav-bar></app-nav-bar>
  <app-home-page></app-home-page>
  <app-footer></app-footer>
</div>
